"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlatformFilter = void 0;
const builtin_1 = require("./builtin");
class PlatformFilter {
    constructor(platform) {
        this.platform = platform;
        this.resolvers = {
            ...builtin_1.builtinResolvers
        };
        this.operators = {
            ...builtin_1.builtinOperators
        };
    }
    /**
     * Add a single resolver to the filter list
     *
     * @param name of the resulter
     * @param resolver
     */
    addResolver(name, resolver) {
        this.resolvers = {
            ...this.resolvers,
            [name]: resolver
        };
    }
    /**
     * Extends builtin resolvers
     *
     * @param resolvers A dictionary of <resolverName, resolver>
     */
    addResolvers(resolvers) {
        this.resolvers = {
            ...this.resolvers,
            ...resolvers
        };
    }
    /**
     * Extends builtin logical operators
     *
     * @param operators A dictionary of <operatorName, logicalFunction>
     */
    addOperators(operators) {
        this.operators = {
            ...this.operators,
            ...operators
        };
    }
    /**
     * Checks whether or not a contribution is filtered based on environment
     *
     * Filters allow certain plugins to be disabled based on environmental criteria,
     * for example: account permissions, or if some global setting
     * This method will recursively iterate over the filters with the current env and
     * return true or false if all resolvers passed
     *
     * @see {@link http://dna-ui.cisco.com/guides/contributionmodel/contribution-model/#filters} to check $filter docs
     * @param contribData Contribution to check
     * @param sourcePluginId The ID of the plugin where contribution is defined
     * @param qualifiedExtPoint Extension point which receives contribution
     * @returns `true` if all resolvers were passed
     */
    allowContribution(contribData, sourcePluginId, qualifiedExtPoint) {
        const filterData = {
            // support previous ways of specifying filters for compat purposes
            ...(contribData.requiredPermissions
                ? { permissions: contribData.requiredPermissions }
                : {}),
            ...contribData.$filter
        };
        const isInternal = sourcePluginId.startsWith("cisco.dna.core");
        const onError = (key) => {
            // eslint-disable-next-line no-console
            console.warn(`Unknown contribution filter "${key}" specified in ${sourcePluginId}'s contribution to ${qualifiedExtPoint}`, contribData);
        };
        const apply = (fnName, value) => {
            if (this.operators[fnName]) {
                const operatorFn = this.operators[fnName];
                const arrValues = (0, builtin_1.flatten)(value);
                if (arrValues.length === 0) {
                    return true;
                }
                const results = arrValues.map(item => {
                    if (typeof item === "boolean") {
                        return item;
                    }
                    const fnName = Object.keys(item)[0];
                    return apply(fnName, item[fnName]);
                });
                return operatorFn(results);
            }
            else if (this.resolvers[fnName]) {
                const context = {
                    platform: this.platform,
                    isInternal,
                    sourcePluginId,
                    qualifiedExtPoint
                };
                return this.resolvers[fnName](value, context, apply, onError);
            }
            else {
                onError(fnName);
                return true;
            }
        };
        return apply("$and", filterData);
    }
}
exports.PlatformFilter = PlatformFilter;
